import {
  EDIT_BUSINESS, DELETE_BUSINESS, CREATE_BUSINESS, CREATE_BUSINESS_SUCCESS, UPDATE_BUSINESS_SUCCESS,GET_BUSINESS,GET_BUSINESS_SUCCESS,
  UPDATE_BUSINESS, DELETE_BUSINESS_SUCCESS, FETCH_ALL_BUSINESS, FETCH_ALL_BUSINESS_SUCCESS, SET_BUSINESS, SET_ROLE
} from 'constants/businesses.constants'
import { startLoader } from 'actions/general.action';

export const setBusiness = (key, value) => {
  return {
    type: SET_BUSINESS,
    key: key,
    value: value
  }
}

export const setRoles = (key, value) => {
  return {
    type: SET_ROLE,
    key: key,
    value: value
  }
}

export const fetchBusinesss = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_BUSINESS,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchBusinesssSuccess = (data) => {
  return {
    type: FETCH_ALL_BUSINESS_SUCCESS,
    payload: data
  };
};

export const deleteBusiness = (id) => {
  return {
    type: DELETE_BUSINESS,
    payload: id
  };
};

export const editBusiness = (id) => {
  return {
    type: EDIT_BUSINESS,
    payload: id
  };
};

export const getBusiness = (id) => {
  return {
    type: GET_BUSINESS,
    payload: id
  };
};

export const createBusiness = (payload) => {
  console.log(payload)
  return {
    type: CREATE_BUSINESS,
    payload: payload
  };
};

export const getBusinessSuccess = (payload) => {
  return {
    type: GET_BUSINESS_SUCCESS,
    payload: payload
  };
}

export const createBusinessSuccess = (payload) => {
  return {
    type: CREATE_BUSINESS_SUCCESS,
    payload: payload
  };
};

export const updateBusinessSuccess = (data) => {
  return {
    type: UPDATE_BUSINESS_SUCCESS,
    payload: data
  };
};

export const deleteBusinessSuccess = (data) => {
  return {
    type: DELETE_BUSINESS_SUCCESS,
    payload: data
  };
};

export const updateBusiness = (payload) => {
  return {
    type: UPDATE_BUSINESS,
    payload: payload
  };
}; 